import { useRouteResponse } from "@src/app/hooks/useRouteResponse";

import { BFF_ENDPOINT } from "../utils/bff";

export function useArticleSEO() {
  const res = useRouteResponse("articlePage");
  const article = res.article;

  // Get main entity URL
  const mainEntity = `${BFF_ENDPOINT}${article?.urlPath || ""}`;

  // Generate SEO JSON-LD string
  const articleSEOStr = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": article?.urlPath ? mainEntity : "",
    },
    headline: article?.title || "",
    image: "",
    datePublished: article?.created || "",
    dateModified: article?.updated || "",
    publisher: {
      "@type": "Organization",
      name: "Think China",
      logo: {
        "@type": "ImageObject",
        url: "/src/app/assets/logo@2x.svg",
      },
    },
    author: [
      {
        "@type": "Person",
        name: article?.authors[0]?.name || "",
        url: article?.authors[0]?.urlPath || "",
      },
    ],
    description: article?.standfirst || "",
  };
  return {
    articleSEOStr: JSON.stringify(articleSEOStr),
  };
}
